// Safety & Compliance document types a driver can upload.
// Keep keys in sync with COMPLIANCE_DOC_TYPES in backend/server.py.
export const COMPLIANCE_DOC_TYPES = [
  { key: "drivers_license", label: "Drivers License" },
  { key: "vehicle_registration", label: "Vehicle Registration" },
  { key: "vehicle_insurance", label: "Vehicle Insurance (Comprehensive)" },
  { key: "public_liability", label: "Public Liability Insurance" },
  { key: "marine_goods_transit", label: "Marine and Goods in Transit" },
  { key: "dg_goods_license", label: "DG Goods License" },
  { key: "other_certificates", label: "Other Certificates (eg: Forklift ticket)" },
  { key: "trailer_registration", label: "Registration Document on Trailer" },
];
